var _path, _line, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 58,
    viewBox: "0 0 8 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.69892C7.5 5.42952 5.97056 6.89785 4 6.89785C2.02944 6.89785 0.5 5.42952 0.5 3.69892C0.5 1.96833 2.02944 0.5 4 0.5C5.97056 0.5 7.5 1.96833 7.5 3.69892Z",
    fill: "#B3261E",
    stroke: "#B3261E"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 4,
    x2: 4.5,
    y2: 54,
    stroke: "#B3261E",
    strokeDasharray: "2 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 54.301C7.5 56.0316 5.97056 57.4999 4 57.4999C2.02944 57.4999 0.5 56.0316 0.5 54.301C0.5 52.5704 2.02944 51.1021 4 51.1021C5.97056 51.1021 7.5 52.5704 7.5 54.301Z",
    fill: "#B3261E",
    stroke: "#B3261E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartMarker);
export default __webpack_public_path__ + "static/media/chart-marker.1893bee64e08af604b38433a42ddb4f8.svg";
export { ForwardRef as ReactComponent };